import Currencies from './Currencies';

export default Currencies;


// WEBPACK FOOTER //
// ./src/components/Query/Currencies/index.ts